<div class="dialog-content-wrapper" *ngIf="esModal">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate" *ngIf="contratista"
                >{{ contratista.nombres }}, {{ contratista.apellidos }}</span
            >
            <button
                style="float: right"
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <mat-tab-group dynamicHeight="true">
            <mat-tab [label]="etiquetas.identificacion">
                <div class="p-24">
                    <app-identificacion
                        *ngIf="contratista"
                        [contratista]="contratista"
                        [eliminado]="eliminado"
                        [esModal]="esModal"
                        (eliminarContratista)="eliminarContratista($event)"
                        (editarContratista)="editarContratista($event)"
                    ></app-identificacion>
                </div>
            </mat-tab>

            <mat-tab [label]="etiquetas.certificaciones">
                <div class="p-24">
                    <app-certificaciones
                        *ngIf="contratista"
                        [puedeEditar]="true"
                        [rutContratista]="rutContratista"
                        [eliminado]="eliminado"
                        (eliminarCertificacion)="eliminarCertificacion($event)"
                        (agregarDocumento)="agregarDocumento($event)"
                    ></app-certificaciones>
                </div>
            </mat-tab>

            <mat-tab [label]="etiquetas.especialidades">
                <div class="p-24">
                    <app-especialidades
                        *ngIf="contratista"
                        [eliminado]="eliminado"
                        [especialidades]="contratista.gruposServicio"
                        (eliminarEspecialidad)="eliminaEspecialidad($event)"
                        (agregarEspecialidades)="agregarEspecialidades()"
                    ></app-especialidades>
                </div>
            </mat-tab>

            <mat-tab
                [label]="etiquetas.disponibilidad"
                *ngIf="_menuUsuarioSrvc.esSupervisor()"
            >
                <div class="p-24">
                    <app-disponibilidad
                        *ngIf="contratista"
                        [eliminado]="eliminado"
                        [comunas]="contratista.comunas"
                        (eliminarComuna)="eliminaComuna($event)"
                        (agregarZonasCobertura)="agregarZonasCobertura()"
                    ></app-disponibilidad>
                </div>
            </mat-tab>

            <mat-tab
                [label]="etiquetas.horarios"
                *ngIf="_menuUsuarioSrvc.esSupervisor()"
            >
                <div class="p-24">
                    <app-horarios
                        *ngIf="contratista"
                        [horarios]="contratista.horario"
                    >
                    </app-horarios>
                </div>
            </mat-tab>

            <mat-tab
                [label]="etiquetas.solicitudes"
                *ngIf="_menuUsuarioSrvc.esSupervisor()"
            >
                <div class="p-24">
                    <app-especialidades-solicitadas
                        *ngIf="contratista && grupoServiciosSolicitados"
                        [especialidades]="contratista.gruposServicio"
                        [eliminado]="eliminado"
                        [contratista]="contratista"
                        [grupoServiciosSolicitados]="grupoServiciosSolicitados"
                        (aprobarSolicitudEvent)="aprobarSolicitud($event)"
                    ></app-especialidades-solicitadas>
                </div>
            </mat-tab>

            <mat-tab
                [label]="etiquetas.pago"
                *ngIf="_menuUsuarioSrvc.esSupervisor()"
            >
                <div class="p-24">
                    <app-pago
                        *ngIf="contratista"
                        [contratista]="contratista"
                        [eliminado]="eliminado"
                        (openDialogActualizaPago)="editarContratista($event)"
                    ></app-pago>
                </div>
            </mat-tab>
        </mat-tab-group>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-raised-button color="accent" mat-dialog-close>
            Cerrar
        </button>
    </mat-dialog-actions>
</div>

<div class="page-layout simple fullwidth" *ngIf="!esModal">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="row" fxLayoutAlign="start center">
            <button
                mat-icon-button
                class="mr-0 mr-sm-16"
                [routerLink]="'/contratistas'"
            >
                <mat-icon>arrow_back</mat-icon>
            </button>

            <div
                fxLayout="column"
                fxLayoutAlign="start start"
                [@animate]="{
                    value: '*',
                    params: { delay: '100ms', x: '-25px' }
                }"
            >
                <div class="h2" *ngIf="contratista">
                    {{ contratista.nombres }}, {{ contratista.apellidos }}
                </div>

                <div class="subtitle secondary-text" *ngIf="contratista">
                    <span>{{ contratista.rut }}</span>
                </div>
            </div>
        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->

    <div class="center p-24 pb-56" fusePerfectScrollbar>
        <div class="content">
            <div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
                <mat-tab-group dynamicHeight="true">
                    <mat-tab [label]="etiquetas.identificacion">
                        <div class="p-24">
                            <app-identificacion
                                *ngIf="contratista"
                                [eliminado]="eliminado"
                                [esModal]="esModal"
                                [contratista]="contratista"
                                (eliminarContratista)="
                                    eliminarContratista($event)
                                "
                                (editarContratista)="editarContratista($event)"
                            ></app-identificacion>
                        </div>
                    </mat-tab>

                    <mat-tab [label]="etiquetas.certificaciones">
                        <div class="p-24">
                            <app-certificaciones
                                *ngIf="contratista"
                                [puedeEditar]="true"
                                [eliminado]="eliminado"
                                [rutContratista]="rutContratista"
                                (eliminarCertificacion)="
                                    eliminarCertificacion($event)
                                "
                                (agregarDocumento)="agregarDocumento($event)"
                            ></app-certificaciones>
                        </div>
                    </mat-tab>

                    <mat-tab [label]="etiquetas.especialidades">
                        <div class="p-24">
                            <app-especialidades
                                *ngIf="contratista"
                                [eliminado]="eliminado"
                                [especialidades]="contratista.gruposServicio"
                                (eliminarEspecialidad)="
                                    eliminaEspecialidad($event)
                                "
                                (agregarEspecialidades)="
                                    agregarEspecialidades()
                                "
                            ></app-especialidades>
                        </div>
                    </mat-tab>

                    <mat-tab
                        [label]="etiquetas.disponibilidad"
                        *ngIf="_menuUsuarioSrvc.esSupervisor()"
                    >
                        <div class="p-24">
                            <app-disponibilidad
                                *ngIf="contratista"
                                [eliminado]="eliminado"
                                [comunas]="contratista.comunas"
                                (eliminarComuna)="eliminaComuna($event)"
                                (agregarZonasCobertura)="
                                    agregarZonasCobertura()
                                "
                            ></app-disponibilidad>
                        </div>
                    </mat-tab>

                    <mat-tab
                        [label]="etiquetas.horarios"
                        *ngIf="_menuUsuarioSrvc.esSupervisor()"
                    >
                        <div class="p-24">
                            <app-horarios
                                *ngIf="contratista"
                                [horarios]="contratista.horario"
                            >
                            </app-horarios>
                        </div>
                    </mat-tab>

                    <mat-tab
                        [label]="etiquetas.solicitudes"
                        *ngIf="_menuUsuarioSrvc.esSupervisor()"
                    >
                        <div class="p-24">
                            <app-especialidades-solicitadas
                                *ngIf="contratista && grupoServiciosSolicitados"
                                [eliminado]="eliminado"
                                [especialidades]="contratista.gruposServicio"
                                [contratista]="contratista"
                                [grupoServiciosSolicitados]="
                                    grupoServiciosSolicitados
                                "
                                (aprobarSolicitudEvent)="
                                    aprobarSolicitud($event)
                                "
                            ></app-especialidades-solicitadas>
                        </div>
                    </mat-tab>

                    <mat-tab
                        [label]="etiquetas.pago"
                        *ngIf="_menuUsuarioSrvc.esSupervisor()"
                    >
                        <div class="p-24">
                            <app-pago
                                *ngIf="contratista"
                                [eliminado]="eliminado"
                                [contratista]="contratista"
                                (openDialogActualizaPago)="
                                    editarContratista($event)
                                "
                            ></app-pago>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>

    <!-- / CONTENT -->
</div>
